import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useUserProfile } from "./hooks";
import { Loading } from "@parkschannel/ui";
import { UserPageContentWrapper, UserPageWrapper, UserSubpageWrapper } from "./Wrappers";
import { ProfileCover } from "./ProfileCover";
import { UserPublicInfo } from "./UserInfo";
import { LinkCounter, MainTabs } from "./MainTabs";
import { VideoModalProvider } from "../Video";
import { UserPublicProfileSeo } from "./UserPublicProfileSeo";
import { useButtonsAnalytics } from "../../utils";
export const UserPublicProfile = (param)=>{
    let { children , id  } = param;
    useButtonsAnalytics();
    const { useUserProfileQuery , useUserResourceCountQuery  } = useUserProfile();
    const { data: userProfile , isLoading  } = useUserProfileQuery(id);
    const { data: resourceCount  } = useUserResourceCountQuery(id);
    if (!userProfile || isLoading) return /*#__PURE__*/ _jsx(Loading, {});
    return /*#__PURE__*/ _jsxs(VideoModalProvider, {
        children: [
            /*#__PURE__*/ _jsx(UserPublicProfileSeo, {
                user: userProfile
            }),
            /*#__PURE__*/ _jsxs(UserPageWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(ProfileCover, {
                        src: userProfile.background_key
                    }),
                    /*#__PURE__*/ _jsxs(UserPageContentWrapper, {
                        children: [
                            /*#__PURE__*/ _jsx(UserPublicInfo, {
                                user: userProfile
                            }),
                            /*#__PURE__*/ _jsxs(UserSubpageWrapper, {
                                children: [
                                    /*#__PURE__*/ _jsx(MainTabs, {
                                        links: [
                                            {
                                                href: "/users/".concat(id, "/#nav-scroll"),
                                                match: "/users/[id]",
                                                text: /*#__PURE__*/ _jsx(LinkCounter, {
                                                    name: "My Videos",
                                                    counter: resourceCount && resourceCount.videosCount
                                                })
                                            },
                                            {
                                                href: "/users/".concat(id, "/parks/#nav-scroll"),
                                                match: "/users/[id]/parks",
                                                text: /*#__PURE__*/ _jsx(LinkCounter, {
                                                    name: "My Parks",
                                                    counter: resourceCount && "".concat(resourceCount.unlockedStickersCount, "/").concat(resourceCount.parksWithStickersCount)
                                                })
                                            }
                                        ]
                                    }),
                                    typeof children === "function" ? children(userProfile) : children
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
